import React from "react";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import ToolTip from "../common/ToolTip";
import SetCaseMenuSizeComponent from "./SetCaseMenuSizeComponent.jsx";
import SetFontSizeComponent from "./SetFontSizeComponent.jsx";

class GlobalContextMenu extends React.Component {
    constructor(props) {
        super(props);
    }

    render = () => {
        let { Dyn, getLoc } = this.props;

        return (
            <React.Fragment>
                <div className="tde-p-1">
                    {!Dyn.plotUtil.isTuvaJr() && Dyn.plotView.isDualAxisAllowed() && (
                        <div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                            <label className="text-normal">
                                <span className="flex-1">
                                    {getLoc("Dual Axis")}
                                    <ToolTip
                                        tip={getLoc(
                                            "Add second y-axis to scatter plot or line plot"
                                        )}
                                        Dyn={Dyn}
                                    >
                                        <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                    </ToolTip>
                                </span>
                            </label>
                            <Toggle
                                aria-label={getLoc("Dual Axis")}
                                id="tde-global-dual-axis-toggle"
                                className="black-toggle"
                                icons={false}
                                onChange={(e) => {
                                    Dyn.preferences.setWantY2Axis(
                                        e.target.checked
                                    );
                                }}
                            />
                        </div>
                    )}
                    <div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                        <label className="text-normal">
                            <span className="flex-1">
                                {getLoc("Grid Lines")}
                                <ToolTip
                                    tip={getLoc(
                                        "Add gridlines to the plotting area"
                                    )}
                                    Dyn={Dyn}
                                >
                                    <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                </ToolTip>
                            </span>
                        </label>
                        <Toggle
                            aria-label={getLoc("Grid Lines")}
                            checked={Dyn.preferences.isGridLinesOn()}
                            id="tde-global-grid-lines-toggle"
                            className="black-toggle"
                            icons={false}
                            onChange={(e) => {
                                Dyn.preferences.setGridLinesOn(e.target.checked);
                                this.setState({});
                            }}
                        />
                    </div>
                    {!Dyn.plotUtil.isDrawOnly() && (<div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                        <label className="text-normal">
                            <span className="flex-1">
                                {getLoc("Labels")}
                                <ToolTip
                                    tip={getLoc(
                                        "Add labels in the plotting area"
                                    )}
                                    Dyn={Dyn}
                                >
                                    <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                </ToolTip>
                            </span>
                        </label>
                        <Toggle
                            aria-label={getLoc("Labels")}
                            checked={Dyn.preferences.isStatsLabelOn()}
                            className="black-toggle"
                            id="tde-global-label-toggle"
                            icons={false}
                            onChange={(e) => {
                                Dyn.preferences.toggleStatsLabel();
                                this.setState({});
                            }}
                        />
                    </div>)
                    }
                </div>
                <div className="tde-border-top tde-my-2"></div>
                <div className="tde-p-1">
                    <div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                        <label className="text-normal">
                        {getLoc("Font Size")}
                            <span className="flex-1">
                                <ToolTip
                                    tip={getLoc(
                                        "Increase or decrease the font size"
                                    )}
                                    Dyn={Dyn}
                                >
                                    <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                </ToolTip>
                            </span>
                        </label>
                        <SetFontSizeComponent
                            getLoc={getLoc}
                            Dyn={this.props.Dyn}
                            isFromContextMenu={true}
                        />
                    </div>
                    {!Dyn.plotUtil.isDrawOnly() && (<div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between tde-mb-2">
                        <label className="text-normal">
                            <span className="flex-1">
                            {getLoc("Case Size")}
                                <ToolTip
                                    tip={getLoc(
                                        "Increase or decrease the case icon size"
                                    )}
                                    Dyn={Dyn}
                                >
                                    <i className="tde-i tde-i-exclamation tde-ml-2"></i>
                                </ToolTip>
                            </span>
                        </label>
                        <SetCaseMenuSizeComponent
                            getLoc={getLoc}
                            Dyn={this.props.Dyn}
                            isFromContextMenu={true}
                        />
                    </div>)}
                </div>
            </React.Fragment>
        );
    };
}

export default GlobalContextMenu;
